import { gql } from "lib/apolloClient";

export const upsertCourseAttendanceMutationV3 = gql`
  mutation upsertCourseAttendance(
    $courseId: ID
    $date: String!
    $studentAttendance: [StudentAttendanceValueInput!]
    $shouldSendSMS: Boolean
    $periodId: ID
    $showDeletedRemark: Boolean
    $academicYearId: ID
    $curriculumProgramId: ID
    $pushToSISOption: PushAttendanceToSISInput
  ) {
    platform {
      upsertCourseAttendanceV3(
        input: {
          courseId: $courseId
          date: $date
          studentAttendance: $studentAttendance
          shouldSendSMS: $shouldSendSMS
          periodId: $periodId
          showDeletedRemark: $showDeletedRemark
          academicYearId: $academicYearId
          curriculumProgramId: $curriculumProgramId
          pushToSISOption: $pushToSISOption
        }
      ) {
        warning
        isSuccess
        __typename
      }
      __typename
    }
  }
`;

export const bulkUpsertCourseAttendanceMutation = gql`
  mutation bulkUpsertCourseAttendance(
    $attendanceData: [BulkStudentAttendanceInput!]
    $shouldSendSMS: Boolean
    $academicYearId: ID
    $curriculumProgramId: ID
    $pushToSISOption: PushAttendanceToSISInput
  ) {
    platform {
      bulkUpsertCourseAttendance(
        input: {
          attendanceData: $attendanceData
          shouldSendSMS: $shouldSendSMS
          academicYearId: $academicYearId
          curriculumProgramId: $curriculumProgramId
          pushToSISOption: $pushToSISOption
        }
      ) {
        warning
        isSuccess
        __typename
      }
      __typename
    }
  }
`;

export const syncAttendanceServiceMutation = gql`
  mutation syncAttendanceService($input: IntegrationSyncAttendanceInput!) {
    integration {
      integrationSyncAttendance(input: $input) {
        allow
        message
      }
    }
  }
`;

export const updateAttendanceAutoMarkingSettingsMutation = gql`
  mutation UpdateAttendanceAutoMarkingSettings(
    $input: AttendanceAutoMarkingSettingsInput!
  ) {
    platform {
      updateAttendanceAutoMarkingSettings(input: $input)
    }
  }
`;
